import * as localStorages from "./localStorage"

export const localStorage = localStorages
export default localStorage